import React from "react";
import "../BodyContainer.css"; // Import CSS for styling

function BodyContainer({ children }) {
  return <div className="body-container">{children}</div>;
}

export default BodyContainer;
